import styled from 'styled-components';
import { RawButton } from '../../../../CommonComponents/OPL/Button/Button.styles';

interface Props {
  variant: 'primary' | 'secondary';
  isSelected?: boolean;
  isSelectable?: boolean;
}

export const StyledSelectableAccordionButton = styled(RawButton)<Props>(
  ({ isSelected, isSelectable, variant, theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    alignItems: 'stretch',
    width: '100%',
    borderRadius: 0,
    background: isSelected ? theme.colors.primary['100'] : theme.colors.neutral['100'],
    color: isSelected ? theme.colors.primary['600'] : theme.colors.neutral['700'],
    padding: '8px 12px',
    borderBottom: `1px solid ${
      isSelected ? theme.colors.primary['200'] : theme.colors.neutral['200']
    }`,
    position: 'relative',
    textAlign: 'left',
    paddingLeft: 36,
    cursor: isSelectable ? 'pointer' : 'default',
    transition: `background ${theme.transitions.normal}, color ${theme.transitions.normal}`,

    ...(variant === 'secondary' && {
      background: isSelected ? theme.colors.primary['100'] : theme.colors.primary['50'],
      borderBottom: `1px solid ${theme.colors.primary['200']}`,
    }),

    '&:not(.disabled):focus': {
      backgroundColor: isSelected ? theme.colors.primary['100'] : theme.colors.neutral['100'],

      ...(variant === 'secondary' && {
        background: isSelected ? theme.colors.primary['100'] : theme.colors.primary['50'],
      }),
    },

    '&:not(.disabled):hover, &:not(.disabled):active': {
      backgroundColor: isSelected
        ? isSelectable
          ? theme.colors.primary['200']
          : theme.colors.primary['100']
        : isSelectable
        ? theme.colors.neutral['200']
        : theme.colors.neutral['100'],

      ...(variant === 'secondary' && {
        backgroundColor: isSelectable ? theme.colors.primary['100'] : theme.colors.primary['50'],
      }),
    },

    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      width: 3,
      backgroundColor: isSelected ? theme.colors.primary['500'] : 'transparent',
    },
  }),
);

interface ExpandButtonProps {
  variant: 'primary' | 'secondary';
  isSelected?: boolean;
}

export const ExpandButton = styled(RawButton)<ExpandButtonProps>(
  ({ isSelected, variant, theme }) => ({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    borderRadius: 0,
    paddingLeft: 4,
    paddingRight: 4,
    lineHeight: 0,
    height: '100%',
    width: 36,
    color: isSelected ? theme.colors.primary['600'] : theme.colors.neutral['500'],

    ...(variant === 'secondary' && {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: 11,
      color: theme.colors.primary['600'],
    }),
  }),
);
